"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'bindEquip',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      form: {},
      list: [],
      listLoading: true,
      listQuery: {
        search_goods_type: '1',
        is_distributed: '1',
        search_user_type: 0,
        page_num: 1
      },
      selSnArr: []
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 校验是否可选
     */
    checkSel: function checkSel(row) {
      return true;
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 选择设备
     * @param {Object} res
     */
    selSb: function selSb(list) {
      var selSnArr = [];
      for (var i in list) {
        selSnArr.push(list[i].goods_sn);
      }
      this.selSnArr = selSnArr;
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/search/query_devices', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * @param {Object} row
     * 绑定广告
     */
    bindAd: function bindAd(row) {
      var _this2 = this;
      var selSnArr = this.selSnArr;
      if (row) selSnArr.push(row.goods_sn);

      // 【操作埋点】2026-05-25 pc_ad_bind_1 绑定广告到设备
      this.$post('agentapi/bind_ad_sns', {
        id: this.id,
        goods_sn: selSnArr
      }, {
        operation_option: '绑定广告设备',
        content: "\u5E7F\u544AID ".concat(this.id, " \u7ED1\u5B9A\u5230 ").concat(selSnArr.length, " \u53F0\u8BBE\u5907\uFF0CSN\uFF1A").concat(selSnArr.join(',')),
        operation_id: 'pc_ad_bind_1'
      }).then(function (res) {
        _this2.$message({
          message: '绑定成功',
          type: 'success'
        });
        history.back();
      });
    }
  }
};